const Mode = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export default Mode;
